import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ProductionDeclarationMaterialCommentForm } from '@/features/production-declaration/components/statement/production-declaration-material-comment-form';

type ProductionDeclarationMaterialCommentEditDialogProps = {
  comment: string;
  isPending: boolean;
  onCancel: () => void;
  onChange: (comment: string) => void;
  onOpenChange: (open: boolean) => void;
  onSubmit: () => void;
  open: boolean;
};

export function ProductionDeclarationMaterialCommentEditDialog({
  comment,
  isPending,
  onCancel,
  onChange,
  onOpenChange,
  onSubmit,
  open,
}: ProductionDeclarationMaterialCommentEditDialogProps) {
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });
  const { t: tCommon } = useTranslation('common', {
    useSuspense: false,
  });

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t('materialCommodityOrigins.comments.editTitle')}
          </DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <ProductionDeclarationMaterialCommentForm
          comment={comment}
          description={t('materialCommodityOrigins.comments.editDescription')}
          isPending={isPending}
          onCancel={onCancel}
          onChange={onChange}
          onSubmit={onSubmit}
          submitLabel={tCommon('save')}
        />
      </DialogContent>
    </Dialog>
  );
}
